import { decodeJwt } from '../../shared/utils/functions/decodeJwt/decodeJwt.js';
import '../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import 'react/jsx-runtime';
import '../ViewContext/ViewContext.js';
import 'react';
import { AUTH_TOKEN } from '../../utils/constants/localStorage.js';
import '../../utils/constants/colors.js';

let logoutTimer;
const isAuthTokenExpired = (token) => {
    const decoded = decodeJwt(token);
    if (!decoded) {
        return true;
    }
    if (!decoded.exp) {
        return true;
    }
    const expirationTime = new Date(decoded.exp * 1000).getTime();
    const currentTime = new Date().getTime();
    if (currentTime >= expirationTime) {
        return true;
    }
    return false;
};
const initExpirationTime = (logout) => {
    const decodedJwt = decodeJwt(localStorage.getItem(AUTH_TOKEN));
    if (!decodedJwt)
        return clearTimeout(logoutTimer);
    const tokenExp = decodedJwt === null || decodedJwt === void 0 ? void 0 : decodedJwt.exp;
    if (!tokenExp) {
        clearTimeout(logoutTimer);
        return logout();
    }
    const expirationTime = new Date(tokenExp * 1000).getTime();
    const currentTime = new Date().getTime();
    if (currentTime >= expirationTime) {
        clearTimeout(logoutTimer);
        return logout();
    }
    const expirationTimeInMs = expirationTime - currentTime;
    // If value is greater than 2,147,483,647 ms (about 24.8 days), there's an integer overflow
    // and the callback will fire imediately
    // https://developer.mozilla.org/en-US/docs/Web/API/setTimeout#maximum_delay_value
    const expiryTimeout = Math.min(expirationTimeInMs, 2147483647);
    logoutTimer = setTimeout(logout, expiryTimeout);
};

export { initExpirationTime, isAuthTokenExpired };
